import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { flowFetch, FlowArea, FlowUser, FlowComment, formatDate } from './flowApi';
import { TaskDetailModal } from './FlowTasks';

export function FlowCommentsInbox({ areas, users }: { areas: FlowArea[]; users: FlowUser[] }) {
  const [comments, setComments] = useState<FlowComment[]>([]);
  const [loading, setLoading] = useState(true);
  const [onlyMentions, setOnlyMentions] = useState(false);
  const [detailId, setDetailId] = useState<string | null>(null);

  const load = async () => {
    setLoading(true);
    try {
      const data = await flowFetch('/api/flow/comments/inbox');
      setComments(data.comments);
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Erro ao carregar comentários');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, []);

  const visible = onlyMentions ? comments.filter(c => c.mentioned) : comments;

  return (
    <div>
      <div className="mb-4 flex items-center gap-2">
        <button onClick={() => setOnlyMentions(false)}
          className={`rounded-full px-3 py-1.5 text-xs font-semibold ${!onlyMentions ? 'bg-cyan-600 text-white' : 'border border-slate-200 bg-white text-slate-600'}`}>
          Todos
        </button>
        <button onClick={() => setOnlyMentions(true)}
          className={`rounded-full px-3 py-1.5 text-xs font-semibold ${onlyMentions ? 'bg-cyan-600 text-white' : 'border border-slate-200 bg-white text-slate-600'}`}>
          Onde fui marcado
        </button>
      </div>

      {loading ? (
        <div className="flex justify-center py-12"><div className="h-8 w-8 animate-spin rounded-full border-b-2 border-cyan-600"></div></div>
      ) : visible.length === 0 ? (
        <p className="py-12 text-center text-slate-400">Nenhum comentário por aqui.</p>
      ) : (
        <div className="space-y-2">
          {visible.map(c => (
            <div key={c.id}
              onClick={() => c.taskId && setDetailId(c.taskId)}
              className={`rounded-xl border bg-white px-4 py-3 shadow-sm ${c.taskId ? 'cursor-pointer hover:border-cyan-300' : ''} ${c.mentioned ? 'border-cyan-300 bg-cyan-50/40' : 'border-slate-200'}`}>
              <div className="mb-1 flex items-center justify-between gap-2">
                <p className="text-xs font-semibold text-slate-600">
                  {c.author?.nome || '—'}
                  {c.contextTitle && <span className="font-normal text-slate-400"> em </span>}
                  {c.contextTitle && <span className="text-slate-700">{c.taskId ? '📋' : '📄'} {c.contextTitle}</span>}
                </p>
                <span className="shrink-0 text-xs text-slate-400">{formatDate(c.createdAt)}</span>
              </div>
              <p className="text-sm text-slate-800">{c.content}</p>
              {c.mentioned && <span className="mt-1 inline-block rounded-full bg-cyan-100 px-2 py-0.5 text-[10px] font-bold text-cyan-700">Você foi marcado</span>}
            </div>
          ))}
        </div>
      )}

      {detailId && <TaskDetailModal taskId={detailId} areas={areas} users={users} onClose={() => setDetailId(null)} onChanged={load} />}
    </div>
  );
}
